export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9481.91125f68.jpg";